import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { MatchService, AuthService } from '../../../services';
import { Match } from '../../../models';
import { ImportEventsDialogComponent, EditGameDialogComponent, AddGameDialogComponent } from '../../dialogs';
import { AngularFireAuth } from '@angular/fire/auth';
import * as FileSaver from 'file-saver';
import { SportsCodeFileExporter } from '../../../converters';

@Component({
  selector: 'match-list',
  templateUrl: './match-list.component.html',
  styleUrls: ['./match-list.component.css']
})
export class MatchListComponent implements OnInit {
  matches: Match[];
  filteredMatches: Match[];
  userId: string;
  loggedIn = false;
  hasMatches = false;
  opened = true;

  isCardLayout = false;
  isListLayout = true;

  /// Active filter rules
  filters = {};

  /// filter-able properties
  team: string;
  grade: string;
  year: string;

  constructor(
    private matchService: MatchService,
    public dialog: MatDialog,
    private authService: AngularFireAuth,
    private exporter: SportsCodeFileExporter
  ) {}

  ngOnInit() {
    console.info(`[match-list]:init`);
    this.authService.authState.subscribe(user => {
      if (user) {
        this.userId = user.uid;
        this.loggedIn = true;
        console.info('[MatchList]:init -> user ', user);

        this.matchService.getForUser(this.userId).subscribe(matches => {
          this.matches = matches;
          this.hasMatches = matches.length > 0;
          this.applyFilters();
          console.info('[MatchList]:matches ', this.matches, this.hasMatches);
        });
      } else {
        this.userId = '';
        this.matches = [];
        this.loggedIn = false;
        this.hasMatches = false;
      }
    });
  }

  cardView() {
    this.isCardLayout = true;
    this.isListLayout = false;
  }

  listView() {
    this.isCardLayout = false;
    this.isListLayout = true;
  }

  onDelete(match: Match): void {
    const response = confirm('are you sure you want to delete?');
    if (response) {
      const isPublished = match.isPublished;
      console.info('[MatchList]:onDelete Deleting match', match);
      this.matchService.delete(match.id);

      if (isPublished) {
        // TODO: Need to delete the published match
      }
    }
  }

  onImport(match: Match): void {
    const dialogRef = this.dialog.open(ImportEventsDialogComponent, {
      height: '500px',
      width: '800px',
      data: match
    });

    dialogRef.afterClosed().subscribe((m: Match) => {
      if (m !== undefined) {
        console.info(`Imported events ${m.id}`);
      }
    });
  }

  onEdit(match: Match): void {
    const dialogRef = this.dialog.open(EditGameDialogComponent, {
      data: match
    });

    dialogRef.afterClosed().subscribe((m: Match) => {
      if (m !== undefined) {
        console.info(`Updated match ${m.id}`);
      }
    });
  }

  onExport(match: Match): void {
    const data = this.exporter.convert(match);
    this.exportFile(data, `${match.name}.xml`, 'text/plain')
  }


  newMatch(): void {
    const dialogRef = this.dialog.open(AddGameDialogComponent);
  }

  private applyFilters() {
    let tmp = this.matches;
    console.info('applyFilters');
    for (const rule of Object.keys(this.filters)) {
      console.info(`applyFilters - rule: ${rule}`);
      tmp = tmp.filter(this.filters[rule]);
    }

    console.info(`applyFilters:`, tmp);
    this.filteredMatches = [...tmp];
  }

  /// filter property by equality to rule
  filterTeam(teamName: string) {
    console.log(`Applying filters for Team: ${teamName}`);
    this.filters[`team`] = (match: Match) => {
      if (teamName === 'None') { return true; }
      return match.homeTeam === teamName || match.awayTeam === teamName;
    };
    this.applyFilters();
  }

  filterGrade(grade: string) {
    console.log(`Applying filters for Grade: ${grade}`);
    this.filters[`grade`] = (match: Match) => {
      if (grade === 'None') { return true; }

      const standardFilters = ['PLM', 'PLW', 'M1M', 'M1W', 'AHL', 'SLM', 'SLW'];

      if (grade === 'Other') {
        return !standardFilters.includes(match.competitionName);
      }

      return match.competitionName === grade;
    };
    this.applyFilters();
  }

  filterYear(year: string) {
    console.log(`Applying filters for Year: ${year}`);
    this.filters[`year`] = (match: Match) => {
      if (year === 'None') { return true; }
      return match.matchDate && new Date(match.matchDate).getFullYear() === parseInt(year, 10);
    };
    this.applyFilters();
  }

  removeFilter(rule: string) {
    delete this.filters[rule];
    this[rule] = null;

    console.info('[MatchList] filters', this.filters);
    this.applyFilters();
  }

  exportFile(data: string, fileName: string, fileType: string) {
    const blob = new Blob([data], { type: fileType });

    FileSaver.saveAs(blob, fileName);
  }
}
